module.exports = __webpack_public_path__ + "static/media/16e-02_Chapas1-2016-405x285mm-lapiz portaminas-HB-sobre-papel-70gr.69a37134.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/16e/16e-02_Chapas1-2016-405x285mm-lapiz portaminas-HB-sobre-papel-70gr.png
// module id = 201
// module chunks = 0